module.exports = __webpack_public_path__ + "img/obs_rain_normal.14cc42e7.svg";